__turbopack_context__.v({
  "default": "spacer-module-scss-module__ieMthq__default",
  "medium": "spacer-module-scss-module__ieMthq__medium",
});
